import { Capacitor } from '@capacitor/core';

// True when running inside the native iOS/Android app (Capacitor shell).
// Returns false on the regular web/PWA build.
export const isNativeApp = () => {
  try {
    return Capacitor.isNativePlatform();
  } catch {
    return false;
  }
};

export const getPlatform = () => {
  try {
    return Capacitor.getPlatform(); // 'ios' | 'android' | 'web'
  } catch {
    return 'web';
  }
};

// True only inside the native iOS app. Apple 3.1.1 forbids selling digital
// subscriptions via anything other than In-App Purchase (and forbids linking out),
// so we hide ALL paid-plan / upgrade / purchase UI when this is true.
export const isIosApp = () => {
  try {
    return Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
  } catch {
    return false;
  }
};
